import React, { Component } from 'react'
import { connect } from 'react-redux'
import composeHOC from 'shared/utils/composeHOC'
import Pagination from 'components/grid/Pagination'
import moment from 'moment';
import {actions} from "modules/aboutUs/redux";
import preload from 'components/enhancer/preload'

class ArticleList extends Component {
  state = {
  }

  constructor(props) {
    super(props)

  }

  componentDidMount(){

  }


newsDetailUrl(linkPrefix,id){
  let urls=linkPrefix.split('/')
  let locations=window.location && window.location.host.split('.')
  let urlId=/^(news|loaninfodetail)*$/.test(urls[2])?('show-'+id+'.html'):id
  if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地
    let childerUrl=''
    childerUrl=urls[2]=='news'?'aboutUs/news/':'aboutUs/loaninfodetail/'
  //  return 'http://'+urls[2]+'.chinatopcredit.com/'+childerUrl+'show-'+id+'.html'
  return 'https://www.chinatopcredit.com/'+childerUrl+urlId

  }else{
    return linkPrefix+urlId


  }
}


  render() {
    const {
      title,
      subtitle,
      linkPrefix,
      pagination,
      items,
      homeNews
    } = this.props

    return (
      <div className="mgauto news-cont">
        <div className="news_banner">
          <h3>{title}</h3>
        </div>
        <div className="newsContent">
          <ul>
            {
              homeNews.map((newsItem, i) => {
                return (
                  <li key={i}>
                    <a href={newsItem.url}>
                      <img src={newsItem.thumb}  alt={newsItem.title} title={newsItem.title} />
                      <span className="newsTitle">{newsItem.title}</span>
                    </a>
                  </li>
                )
              })

            }
          </ul>
        </div>

        <div>
          <div className="list_panel">
            <ul className="DynamicsLists">
              {items && items.map((item, i) => {
                return (
                  <li key={i}>
                    <a href={this.newsDetailUrl(linkPrefix,item.id) } >· {item.title}</a>
                    <span>
                      {moment(item.created_at || item.updated_at || item.publish_time ).format('YYYY-MM-DD')}
                    </span>
                  </li>
                )
              })}
            </ul>
            <div className="list_right">
              <div className="news_wx">
                <img src={require('./images/news_wx.png')}/>
                <p>关注中腾信服务官方微信</p>
              </div>

              <dl>
                <dt>热门动态</dt>
                {items && items.map((item, i) => {
                  return i <= 4 ? (
                    <dd key={i}>
                      <a href={this.newsDetailUrl(linkPrefix, item.id)}>· {item.title}</a>
                    </dd>
                  ): null
                })}
              </dl>

            </div>
          </div>

          {items && <Pagination
            page={pagination.currentPage}
            perPage={pagination.perPage}
            total={pagination.total}
            setPage={this.props.setPage.bind(this)}
            linkPrefix={linkPrefix}
          />}

        </div>
      </div>
    )
  }
}

export default composeHOC(
  connect(state => ({
    homeNews: state.home.homeNews
  }), actions),
  preload(({dispatch, location}) => {

  })
)(ArticleList)



// WEBPACK FOOTER //
// ./components/page/ArticleList.js